module.exports = __webpack_public_path__ + "img/st.1403f2d2.svg";